import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { SupabaseService } from '../services/supabase.service';
import { Observable, map, take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  
  constructor(
    private supabaseService: SupabaseService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> {
    return this.supabaseService.getCurrentUser().pipe(
      take(1),
      map(user => {
        if (user) {
          console.log('AuthGuard: User is authenticated, allowing access', user.email);
          return true;
        } else {
          console.log('AuthGuard: User is not authenticated, redirecting to login');
          this.router.navigate(['/auth/login']);
          return false;
        }
      })
    );
  }
} 